import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyAzNyu7hPshjMNjcMujZJs3UhBGstpCtGI',
  authDomain: 'tarot-website-4f988.firebaseapp.com',
  projectId: 'tarot-website-4f988',
  storageBucket: 'tarot-website-4f988.firebasestorage.app',
  messagingSenderId: '896149704469',
  appId: '1:896149704469:web:444a52b57215b81fc3631c',
  measurementId: 'G-P9LEW1ZD5T',
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
